<template>
  <div
    id="oats-application"
    class="site-wrap logged-in"
  >
    <div class="header">
      <div class="header-inner">
        <div class="nav-top">
          <h1 class="brand">
            <div class="logo">
              <img
                src="./assets/tgln-logo-icon.png"
                :alt="OATS"
              >
            </div>
            <span
              id="app-short-name"
              class="brand-title d-none d-md-flex"
            >Organ Allocation and Transplant System </span>
            <span
              id="app-long-name"
              class="brand-title d-xs-flex d-md-none"
            > OATS </span>
          </h1>
        </div>
      </div>
    </div>
    <div class="content-wrap page-top">
      <div class="container-fluid">
        <h2> DATA TRANSFER TO OATS </h2>
        <div class="page-top-right">
          <div class="system-title d-inline">
            {{ versionAndBuild }}
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <router-view />
    </div>
  </div>
</template>

<script>
import { BUILD_NUMBER, PROJECT_VERSION } from './constants';

export default {
  name: "App",
  data() {
    return {
      versionAndBuild: `v${PROJECT_VERSION} (build #${BUILD_NUMBER})`,
    };
  },
};
</script>

<style scoped>

.header-inner {
  margin-bottom: 1%;
}

.homeTitle div:last-child {
  margin-left: auto;
}

.system-title {
  text-transform: lowercase;
}
</style>

